import { PropsWithChildren, useMemo } from 'react';

import { isRegionLocked, Props as isRegionLockedProps } from '../utils/regionLockedContent';
import { Provinces, useProvince } from '../state/ProvinceProvider';

import Redirect from "./redirect";

export interface Props {
  data: Pick<isRegionLockedProps, 'provinces'>;
  redirect?: string;
  loadingBehavior?: 'show' | 'hide' | 'fallback';
  fallbackRegion?: Provinces
}

const RegionLockedContent = ({
  data,
  children,
  redirect,
  loadingBehavior = 'show',
  fallbackRegion = Provinces.ON,
}: PropsWithChildren<Props>) => {
  // Get the list of provinces from the CMS. If the CMS returns null, assume all provinces.
  const provinces = data?.provinces || Object.values(Provinces);
  const { activeProvince } = useProvince();
  const regionLocked = useMemo(() => isRegionLocked({
    provinces,
    province: activeProvince,
    loadingBehavior,
    fallbackRegion,
  }), [provinces, activeProvince, loadingBehavior, fallbackRegion]);

  if (redirect && regionLocked) {
    return <Redirect to={redirect} />;
  }

  return !regionLocked && children;
};

export default RegionLockedContent;
